const LS_TOKEN = 'token'
const LS_USER_EMAIL = 'user_mail'
const LS_USER_PROVIDER = 'user_provider'
const LS_CURRENT_BOX = 'current_box'
const LS_ALL_BOXES = 'all_boxes'
const LS_TRANSLATIONS = 'translations'

const localStorageUtil = {

  setTranslations (translations) {
    localStorage.setItem(LS_TRANSLATIONS, JSON.stringify(translations))
  },

  getTranslations () {
    const translations = localStorage.getItem(LS_TRANSLATIONS)
    return translations ? JSON.parse(translations) : {}
  },

  setUserEmail (userEmail) {
    localStorage.setItem(LS_USER_EMAIL, JSON.stringify(userEmail))
  },

  getUserEmail () {
    return JSON.parse(localStorage.getItem(LS_USER_EMAIL))
  },

  removeUserEmail () {
    localStorage.removeItem(LS_USER_EMAIL)
  },

  setUserProvider (userProvider) {
    localStorage.setItem(LS_USER_PROVIDER, JSON.stringify(userProvider))
  },

  getUserProvider () {
    return JSON.parse(localStorage.getItem(LS_USER_PROVIDER))
  },

  removeUserProvider () {
    localStorage.removeItem(LS_USER_PROVIDER)
  },

  setAllBoxes (allBoxes) {
    localStorage.setItem(LS_ALL_BOXES, JSON.stringify(allBoxes))
  },

  getAllBoxes () {
    return JSON.parse(localStorage.getItem(LS_ALL_BOXES))
  },

  removeAllBoxes () {
    localStorage.removeItem(LS_ALL_BOXES)
  },

  setCurrentBox (currentBox) {
    localStorage.setItem(LS_CURRENT_BOX, JSON.stringify(currentBox))
  },

  getCurrentBox () {
    return JSON.parse(localStorage.getItem(LS_CURRENT_BOX))
  },

  removeCurrentBox () {
    localStorage.removeItem(LS_CURRENT_BOX)
  },

  setToken (token) {
    localStorage.setItem(LS_TOKEN, token)
  },

  getToken () {
    return localStorage.getItem(LS_TOKEN)
  },

  removeToken () {
    localStorage.removeItem(LS_TOKEN)
  }
}

export default localStorageUtil



// WEBPACK FOOTER //
// ./src/utils/localStorageUtil.js